import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock/mockData';

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Customer <span className="text-amber-700">Testimonials</span>
            </h2>
            <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Hear from our satisfied customers who trust Camel Rubber Bush for their business
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-amber-200 relative"
              >
                {/* Quote Icon */}
                <div className="absolute top-6 right-6 opacity-20">
                  <Quote size={60} className="text-amber-600" />
                </div>

                {/* Rating */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-amber-500 fill-amber-500" size={20} />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 leading-relaxed mb-6 relative z-10 italic">
                  "{testimonial.text}"
                </p>

                {/* Customer Info */}
                <div className="border-t border-amber-300 pt-4">
                  <h4 className="font-bold text-gray-800 text-lg">{testimonial.name}</h4>
                  <p className="text-amber-700 font-medium">{testimonial.company}</p>
                  <p className="text-gray-600 text-sm">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Trust Banner */}
          <div className="mt-16 text-center">
            <div className="inline-block bg-gradient-to-r from-amber-100 to-orange-100 px-8 py-6 rounded-2xl border border-amber-300 shadow-lg">
              <p className="text-2xl font-bold text-gray-800 mb-2">
                Trusted by <span className="text-amber-700">500+</span> Businesses
              </p>
              <p className="text-gray-600">
                Across Gujarat and nearby states
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
